import PropTypes from "prop-types";
import { Box } from "@mui/material";

// Round foot-contour toggle.
export const ContourButton = (props) => {
  const { mode, enabled, onClick } = props;
  const off = mode === "off";
  const bg = off ? "rgba(120,120,120,0.9)" : "#fff";
  const fg = off ? "#fff" : "#000";
  const flipY = mode === "flipped" ? -1 : 1;

  return (
    <Box
      component="button"
      type="button"
      aria-label="Toggle foot contour"
      disabled={!enabled}
      onClick={() => enabled && onClick()}
      sx={{
        position: "relative",
        width: 40,
        height: 40,
        borderRadius: "50%",
        border: "none",
        p: 0,
        backgroundColor: bg,
        opacity: enabled ? 1 : 0.5,
        cursor: enabled ? "pointer" : "default",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* footprint icon */}
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill={fg}
        style={{ transform: `scaleY(${flipY})` }}
      >
        {/* sole: rounded heel, slight arch waist, wider ball */}
        <path d="M12 7.2c-2.7 0-4.4 1.9-4.4 4.5 0 1.4.5 2.5.7 3.7.2 1.4-.1 2.6.3 4 .4 1.5 1.5 2.6 3.4 2.6s2.8-1.2 3.1-2.7c.3-1.5.1-2.7.4-4.1.2-1.2.7-2.2.7-3.5 0-2.7-1.5-4.5-4.2-4.5z" />
        {/* toes: graduated from big toe to little toe */}
        <ellipse cx="8.4" cy="5.2" rx="1.5" ry="1.8" />
        <ellipse cx="11.2" cy="3.7" rx="1.2" ry="1.5" />
        <ellipse cx="13.6" cy="3.7" rx="1.05" ry="1.3" />
        <ellipse cx="15.6" cy="4.4" rx="0.9" ry="1.1" />
        <ellipse cx="17.1" cy="5.6" rx="0.75" ry="0.95" />
      </svg>

      {/* diagonal slash when off */}
      {off && (
        <Box
          sx={{
            position: "absolute",
            width: 28,
            height: 2,
            backgroundColor: fg,
            transform: "rotate(45deg)",
          }}
        />
      )}
    </Box>
  );
};

ContourButton.propTypes = {
  mode: PropTypes.oneOf(["off", "upright", "flipped"]).isRequired,
  enabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
